<template>
  <div class="fccGestaoArquivosParametros">
    <div :class="divWidthChange" class="conteudoWidth">
      <fccTitlePage titlePage="Parâmetros" />
      <div class="row">
        <div class="col-sm-12">
          <fccTable
            striped
            hover
            :fields="Parametros.fields"
            :orderby="sortBy"
            :actions="Parametros.actions"
            addFilter
            :items="listagemGestaoArquivoParametros"
            responsive
            :porPage="itemPorPage"
            search
            pagination
            fieldVisibility
            pdf
            csv
            xls
            :titlePage="titlePage"
            :titlePDF="titlePDF"
          >
          </fccTable>
        </div>
      </div>
    </div>
    <fccModal
      centered
      idModal="addFieldModal"
      :titleModal="titleModal"
      escondeFooter
      travaEsc
      travaBack
    >
      <form
        @submit.prevent="
          gestaoModal === 0 ? criarGestaoArquivoRepositorio() : editarGestaoArquivoRepositorio()
        "
        autocomplete="off"
      >
        <div class="my-2">
          <div class="row innerPage">
            <div class="col-sm-12">
              <fcc-select
                class="mb-4"
                placeholder="Selecione"
                labelField="repodescricao"
                valueField="repoid"
                v-model="criarObj.repoid"
                :options="listagemRepo"
              >
                Repositório
              </fcc-select>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6 my-2">
              <fccInput extraClasses="inputLabel" required v-model="criarObj.repoparcodigo"
                >Código</fccInput
              >
            </div>
            <div class="col-sm-10 my-2">
              <fccInput extraClasses="inputLabel" required v-model="criarObj.repoparhost"
                >Host</fccInput
              >
            </div>
            <div class="col-sm-6 my-2">
              <fccInput extraClasses="inputLabel" required v-model="criarObj.repoparport"
                >Porta</fccInput
              >
            </div>
            <div class="col-sm-6 my-2">
              <fccInput extraClasses="inputLabel" v-model="criarObj.repopardatabase"
                >DataBase</fccInput
              >
            </div>
            <div class="col-sm-6 my-2">
              <fccInput extraClasses="inputLabel" required v-model="criarObj.repoparuser"
                >User</fccInput
              >
            </div>
            <div class="col-sm-6 my-2">
              <fccInput extraClasses="inputLabel" required v-model="criarObj.repoparpass"
                >Password</fccInput
              >
            </div>
            <div class="col-sm-12 my-2">
              <fccInput extraClasses="inputLabel" v-model="criarObj.repoparclientsecretpath"
                >Client Secret Path</fccInput
              >
            </div>
            <div class="col-sm-12 my-2">
              <fccInput extraClasses="inputLabel" v-model="criarObj.repoparwwwroot"
                >www.root</fccInput
              >
            </div>
            <div class="col-sm-6 my-2">
              <fccInput extraClasses="inputLabel" required v-model="criarObj.repoparorigem"
                >Origem</fccInput
              >
            </div>
            <div class="col-sm-6 my-2">
              <fccInput extraClasses="inputLabel" required v-model="criarObj.repopardestino"
                >Destino</fccInput
              >
            </div>
            <div class="col-sm-12 my-2">
              <fccInput extraClasses="inputLabel" v-model="criarObj.repoparambiente"
                >Ambiente</fccInput
              >
            </div>
            <div class="col-sm-12 my-2">
              <fccInput extraClasses="inputLabel" v-model="criarObj.repoparurl">Url</fccInput>
            </div>
            <div class="col-sm-12 my-2">
              <label>Ativo</label><br />
              <toggle-button v-model="criarObj.repoparativo" />
            </div>
          </div>
          <div class="row my-4">
            <div class="col-sm-12 text-right">
              <fccButton type="submit">{{ labelsSystem.salvar }}</fccButton>
            </div>
          </div>
        </div>
      </form>
    </fccModal>
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'

export default {
  data() {
    return {
      name: 'fccGestaoArquivosParametros',
      titlePage: 'Gestão Arquivos - Repositórios - Parâmetros ',
      titlePDF: 'Lista de Gestão Arquivos - Parâmetros',
      itemPorPage: '100',
      listagemRepo: [],
      gestaoModal: 0,
      baseUrlSga: '',
      editar: {},
      titleModal: '',
      listagemGestaoArquivoParametros: [],

      criarObj: {},
      sortBy: 'ordem',
      Parametros: {
        fields: [
          { key: 'repoparid', label: 'ID', sortable: true, active: true },
          { key: 'repoparcodigo', label: 'Código', sortable: true, active: true },
          { key: 'repodescricao', label: 'Descrição', sortable: true, active: true },
          { key: 'repoparhost', label: 'Host', sortable: true, active: true },
          {
            key: 'repoparativo',
            label: 'Ativo',
            active: true,
            funcaoButton: this.editandoBotaoAtivoNaTela,
            tdClass: 'no-print',
            thClass: 'no-print',
            type: 'toggle',
            objpermCodigo: store.state.permissaoMenu.editar
          },

          { key: 'actions', label: '', active: true }
        ],

        actions: [
          {
            button: true,
            funcaoButton: 'editGestaoRepositorio',
            icon: 'edit',
            tooltip: 'Editar',
            objpermCodigo: store.state.permissaoMenu.editar
          },
          {
            button: true,
            funcaoButton: 'deleteGestaoRepositorio',
            icon: 'trash',
            tooltip: 'Excluir',
            objpermCodigo: store.state.permissaoMenu.excluir
          }
        ]
      }
    }
  },
  methods: {
    listandoGestaoArquivosParametros: function () {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlSga + 'RepoParam/ListaTodosRepoParam',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.listagemGestaoArquivoParametros = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    addField: function () {
      this.gestaoModal = 0
      this.criarObj = {}
      this.titleModal = 'Adicionar item'
      this.$root.$emit('bv::show::modal', 'addFieldModal')
    },
    editGestaoRepositorio: function (_, item) {
      this.gestaoModal = 1
      this.titleModal = 'Editar item'
      this.criarObj = { ...item }
      this.$root.$emit('bv::show::modal', 'addFieldModal')
    },
    editandoBotaoAtivoNaTela(_, item) {
      this.criarObj = { ...item }
      this.editarGestaoArquivoRepositorio()
    },
    deleteGestaoRepositorio: function (_, item) {
      this.callConfirm(this.mensagemExcluir, item.repodescricao).then(() => {
        this.carregaTexto(this.codeMensagem('C02'))
        axios
          .delete(
            this.baseUrlSga + 'RepoParam/ExcluirRepoParam?idRepoParam=' + item.repoparid,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(() => {
            this.listandoGestaoArquivosParametros()
            this.carregaTexto()
            this.callToast(this.mensagensUpdate.excluido)
          })
          .catch((error) => {
            this.setErrorSystem(error)
          })
      })
    },
    criarGestaoArquivoRepositorio: function () {
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .post(
          this.baseUrlSga + 'RepoParam/InserirRepoParam',
          this.criarObj,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listandoGestaoArquivosParametros()
          this.carregaTexto()
          this.$root.$emit('bv::hide::modal', 'addFieldModal')
          this.callToast(this.mensagensUpdate.adicionado)
        })
        .catch((error) => {
          this.$root.$emit('bv::hide::modal', 'addFieldModal')
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    },
    editarGestaoArquivoRepositorio: function () {
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .put(
          this.baseUrlSga + 'RepoParam/AlterarRepoParam',
          this.criarObj,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listandoGestaoArquivosParametros()
          this.carregaTexto()
          this.$root.$emit('bv::hide::modal', 'addFieldModal')
          this.callToast(this.mensagensUpdate.editado)
        })
        .catch((error) => {
          this.$root.$emit('bv::hide::modal', 'addFieldModal')
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    },
    listandoRepo: function () {
      axios
        .get(
          this.baseUrlSga + '/Repositorio/ListaTodosRepositorio',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.listagemRepo = response.data
        })
        .catch(this.setErrorSystem)
    }
  },
  mounted: function () {
    this.baseUrlSga = store.state.baseUrlSga
    this.listandoGestaoArquivosParametros()
    this.listandoRepo()
  }
}
</script>
